import { Card } from '../card'
import './style.css'

export function QuickAccess({ cards }) {
  return (
    <section>
      <h2 className="cards-title">Acesso Rápido</h2>
      <div className="cards-section">
        <div className="cards-container">
          {cards.map((card, index) => (
            <Card
              key={index}
              title={card.title}
              icon={card.icon}
              route={card.route}
              image={card.image}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
